import React, { type ReactElement } from 'react';

import * as d from 'date-fns';

import { theme } from '../../style';
import { styles } from '../../style/styles';
import { Block } from '../common/Block';
import { Text } from '../common/Text';

type DateRangeProps = {
  start: string;
  end: string;
  test?: string;
};

export function DateRange({ start, end, test }: DateRangeProps): ReactElement {
  const startDate = d.parseISO(start);
  const endDate = d.parseISO(end);

  if (!d.isValid(startDate) || !d.isValid(endDate)) {
    return (
      <Text style={{ ...styles.mediumText, color: theme.errorText }}>
        There was a problem loading your date range
      </Text>
    );
  }

  let content: string | ReactElement;
  if (startDate.getFullYear() !== endDate.getFullYear()) {
    content = (
      <div>
        {d.format(startDate, 'MMM yyyy')} - {d.format(endDate, 'MMM yyyy')}
      </div>
    );
  } else if (startDate.getMonth() !== endDate.getMonth()) {
    content = (
      <div>
        {d.format(startDate, 'MMM yyyy')} - {d.format(endDate, 'MMM yyyy')}
      </div>
    );
  } else {
    content = d.format(endDate, 'MMMM yyyy');
  }

  return <Block style={{ color: theme.pageTextSubdued }}>{content}</Block>;
}
